import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import callAPI from '../../../API/callSecureAPI'

export type AdminUser = {
    _id: string
    name: string
    email: string
    isAdmin: boolean
    readonly?: boolean
    commentingReadonly?: boolean
    createdAt: string
    lastActivity: string | null
    eventCount: number
}

export type AdminUsersResponse = {
    success: boolean
    data: {
        users: AdminUser[]
        pagination: {
            page: number
            limit: number
            total: number
            totalPages: number
        }
    }
}

const FIVE_MINUTES = 1000 * 60 * 5

export const useAdminUsersByOrgQuery = (orgId: string, page: number = 1, limit: number = 20, search: string = '') => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getUsersByOrg = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const params = new URLSearchParams({
                page: String(page),
                limit: String(limit),
            })
            if (search) {
                params.append('search', search)
            }
            const response = await callAPI(`/api/admin/organizations/${orgId}/users?${params.toString()}`, 'get', token)
            return response
        } catch (e) {
            console.error('Error fetching users:', e)
            throw e
        }
    }

    return useQuery<AdminUsersResponse>(['admin', 'users', orgId, page, limit, search], getUsersByOrg, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!orgId,
        cacheTime: FIVE_MINUTES,
        staleTime: 30000,
        retry: 3,
        keepPreviousData: true,
    })
}
